const mda = () => {
    return (
        <svg width='24' height='48' viewBox='0 0 24 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M19.5 3.20006C14.8 -1.29994 7.50005 -0.999944 3.00005 3.80006C-2.29995 9.50006 -0.39995 18.8001 6.60005 22.1001C7.80005 22.6001 9.10005 22.9001 10.4001 23.4001C10.4001 23.5001 10.4001 23.7001 10.4001 24.0001C10.4001 31.1001 10.4001 38.2001 10.4001 45.2001C10.4001 45.6001 10.4001 46.1001 10.4001 46.5001C10.4001 46.8001 10.5001 47.0001 10.6001 47.3001C10.9001 47.7001 11.3001 47.9001 11.7001 47.7001C12.2001 47.6001 12.5001 47.2001 12.5001 46.6001C12.5001 45.5001 12.5001 44.4001 12.5001 43.4001C12.5001 36.9001 12.5001 30.3001 12.5001 23.8001C12.5001 23.3001 12.7001 23.2001 13.2001 23.0001C14.3001 22.7001 15.4 22.5001 16.4 22.0001C23.8 18.7001 25.4 8.80006 19.5 3.20006ZM14.6001 10.8001C13.0001 10.8001 11.7001 9.40006 11.8001 7.80006C11.9001 6.20006 13.2001 5.00006 14.7001 5.00006C16.3001 5.00006 17.6 6.40006 17.5 8.00006C17.5 9.60006 16.2001 10.9001 14.6001 10.8001Z'
                fill='#F7461C'
            />
            <path
                d='M14.7001 5.1001C13.1001 5.1001 11.8001 6.3001 11.8001 7.9001C11.7001 9.5001 13.1001 10.8001 14.6001 10.9001C16.2001 10.9001 17.5001 9.7001 17.5001 8.1001C17.6001 6.4001 16.3001 5.1001 14.7001 5.1001Z'
                fill='white'
            />
        </svg>
    );
};

export default mda;
